import styled from 'styled-components';

export const Item = styled.div`
  position: relative;
`;

export const EmptySlot = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
